// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__nav-mobile',
    // #endregion
    // #region Methods
    methods: {
        onMobileNavToogle(event) {
            event.stopPropagation();
            this.$host.pageMeta.toogleMobileNav();
        },
    },
    // #endregion
});
// #endregion
